module.exports = "<div>\n  <span>Monthly rate:</span>\n  <strong *ngIf=\"monthlyRate\">${{ monthlyRate | number:'.0' }}</strong>\n  <strong *ngIf=\"!monthlyRate\" class=\"text-muted\">--</strong>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/app/coverage-form/monthly-rate/monthly-rate.component.html
// module id = 564
// module chunks = 1